"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var LegacySelectContext = /*#__PURE__*/React.createContext(null);
var _default = exports.default = LegacySelectContext;